import React from "react";

const Stop = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect  className="u_fill" x={2} y={2} width={32} height={32} rx={6} fill={fill} />
    </svg>
);

export default Stop;

